import { ISelectInputProps, SelectInput } from '@framework/form';
import * as React from 'react';
import { CustomWarningRuleType } from './ICustomWarningRule';

export interface ICustomWarningRuleTypeSelectProps extends ISelectInputProps {}

const WarningTypeOptions = [
  {
    value: CustomWarningRuleType.Warning,
    label: 'Avviso',
  },
  {
    value: CustomWarningRuleType.Error,
    label: 'Errore',
  },
];

export function CustomWarningRuleTypeSelect(
  props: ICustomWarningRuleTypeSelectProps,
) {
  return <SelectInput options={WarningTypeOptions} {...props} />;
}
